import React, { useState } from 'react';
import * as styles from './aiEngineerFellowship.module.scss';
import PostContentCTALayout from '@components/v5/layouts/PostContentCTALayout/index';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import { LEAD_GEN_PROJECTS } from '@src/constants/LeadGenerationConstants/index';
import { ICONS } from './iconRegistry';

const TABS = [
  { key: 'warm', label: 'Mini Projects', count: 10 },
  { key: 'flag', label: 'Guided projects', count: 6 },
  { key: 'cap', label: 'Capstone', count: 1 },
  { key: 'opt', label: 'Optional self-builds', count: 4 },
];

const ProjectsTabs = ({ content }) => {
  const { miniProjects, guidedProjects, capstoneIdeas, optionalProjects } = content;
  const [tab, setTab] = useState('warm');

  return (
    <section id="projects">
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>Projects You&apos;ll Build</h2>
          <p>
            Ship 17 builds — 10 mini projects, 6 guided projects and a capstone — plus 4 optional
            self-builds. Every build ends in a deployed artifact and a measured result: an eval
            report, a cost/latency dashboard, a demo — not a notebook.
          </p>
        </div>

        <div className={styles.tabBar} role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              className={`${styles.tabBtn} ${tab === t.key ? styles.on : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label} <span>{t.count}</span>
            </button>
          ))}
        </div>

        {tab === 'warm' && (
          <div>
            <p className={styles.tabLead}>
              Small, shippable builds that teach the muscle — each one ends in a working, deployed
              artifact and a measured result.
            </p>
            <div className={`${styles.cards2} ${styles.warmPanel}`}>
              {miniProjects.map((mp) => {
                const Icon = ICONS[mp.icon];
                return (
                  <div className={styles.mini} key={mp.num}>
                    <div className={styles.num}>{Icon && <Icon size={18} aria-hidden="true" />}</div>
                    <span className={styles.idx}>{mp.num}</span>
                    <div>
                      <h4>{mp.title}</h4>
                      <span className={styles.tag}>{mp.tag}</span>
                      <p>{mp.p}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {tab === 'flag' && (
          <div>
            <p className={styles.tabLead}>
              Six production apps built with mentors — each deployed and operated with
              evaluation, observability and cost control, and shipped with a one-page spec,
              success metrics and a demo narrative.
            </p>
            <div className={styles.cards3}>
              {guidedProjects.map((gp) => (
                <div className={styles.flag} key={gp.title}>
                  <div className={styles.top}>
                    <span className={styles.badge}>{gp.badge}</span>
                    <h3>{gp.title}</h3>
                    <div className={styles.role}>{gp.role}</div>
                  </div>
                  <div className={styles.body}>
                    <p>{gp.p}</p>
                    <div className={styles.chips}>
                      {gp.chips.map((chip) => (
                        <span className={`${styles.chip} ${styles.g}`} key={chip}>
                          {chip}
                        </span>
                      ))}
                    </div>
                    <div className={styles.ships}>
                      <b>Ships as:</b> {gp.ships.replace('Ships as: ', '')}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {tab === 'cap' && (
          <div>
            <p className={styles.tabLead}>
              Then you build your own AI product — the full problem → production cycle, from
              one-page spec to demo day.
            </p>
            <div className={styles.cap}>
              <div>
                <span className={styles.eyebrow}>Capstone · FDE-style</span>
                <h3>Your own AI product, end to end.</h3>
                <p>
                  Choose from an industry menu, write the one-page spec and success metrics,
                  build, deploy on AWS, evaluate, monitor — and tell the story on demo day.
                </p>
                <ul>
                  {capstoneIdeas.map((idea) => (
                    <li key={idea}>{idea}</li>
                  ))}
                </ul>
              </div>
              <div className={styles.r}>
                <div className={styles.big}>1</div>
                <div style={{ color: '#CFE6E0', fontSize: 14 }}>
                  flagship capstone,
                  <br />
                  fully yours
                </div>
              </div>
            </div>
          </div>
        )}

        {tab === 'opt' && (
          <div>
            <p className={styles.tabLead}>
              Four more, if you want them — self-directed builds with a scaffold, a rubric and
              light mentor checkpoints, in the later sprints or after the program.
            </p>
            <div className={styles.cards4}>
              {optionalProjects.map((op) => (
                <div className={styles.card} key={op.title}>
                  <div className={styles.k}>{op.k}</div>
                  <h4>{op.title}</h4>
                  <p>{op.p}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        <PostContentCTALayout className="mt-8 sm:mt-8">
          <LeadGenerationButton text="Apply Now" buttonLocation={LEAD_GEN_PROJECTS} />
        </PostContentCTALayout>
      </div>
    </section>
  );
};

export default ProjectsTabs;
